// extracted by mini-css-extract-plugin
module.exports = {"widget":"a10a3f92e9--widget--3BBee"};